import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, switchMap, take, finalize, throwError } from "rxjs";
import { AuthService } from "shared/services/auth.service";
import { ObjectUtils } from "shared/utils/object.utils";

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

  private _isRefreshing = false;

  constructor(private _authService: AuthService) { }

  // Intercept request
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if(!request) return next.handle(request)
    if(request instanceof(HttpErrorResponse)) return throwError(() => request);
    // Do not proceed when logout
    if(request.url.includes('logout')) return next.handle(request)


    return next.handle(request).pipe(
      catchError((error) => {
        
        // Must include `TOKEN_EXPIRED` status
        const errorMessage = ObjectUtils.getNestedValue(error,"error.message")
      
        if(errorMessage == 'TOKEN_EXPIRED' && error.status == 401 )  {
          return this._tryGetRefreshToken(request, error, next);
        }

        throw new HttpErrorResponse(error);
             
      })
    );
  }
  
  private _tryGetRefreshToken(request: HttpRequest<any>, error,  next: HttpHandler) {

    if (this._isRefreshing){
      return next.handle(request)
    }
     
    // Toggle is refreshing 
    this._isRefreshing = true;

    if (!this._authService.isLoggedIn()) {
      return next.handle(request)
    }

    // Get new access and refresh token
    return this._authService.getRefreshToken().pipe(
      switchMap(() => {
        const newRequest = request.clone({
          headers: request.headers
            .set('x-access-token', this._authService.accessToken || '')
            .set('x-session-id', this._authService.sessionId || ''),
          withCredentials: true
      });
        return next.handle(newRequest);
      }),
      catchError((refreshError) => {
        return throwError(() => refreshError);
      }),
      finalize(() => {
        // This block will always run, ensuring the flag is reset.
        this._isRefreshing = false;
      })
  )}
}

